export default "__VITE_PUBLIC_ASSET__58408a2a__"